export const VERSION_SERIAL_NUMBER = "Serial number";
export const VERSION_HARDWARE = "Hardware";
export const VERSION_MC_BOOTLOADER = "Main Controller bootloader";
export const VERSION_MC_FIRMWARE = "Main Controller firmware";
export const VERSION_SC_BOOTLOADER = "Safety Controller bootloader";
export const VERSION_SC_FIRMWARE = "Safety Controller firmware";
